import { useState } from 'react';

export const useDeleteSwarmSession = (API_URL) => {
  const [isDeleting, setIsDeleting] = useState(false);

  const deleteSwarmSession = async (sessionId) => {
    if (!API_URL || !sessionId) return false;
    setIsDeleting(true);
    try {
      const response = await fetch(
        `${API_URL}/swarm/sessions/${encodeURIComponent(sessionId)}`,
        { method: 'DELETE', credentials: 'include' }
      );
      if (!response.ok) throw new Error(`HTTP error ${response.status}`);
      return true;
    } catch (error) {
      console.error('Error deleting swarm session:', sessionId, error);
      return false;
    } finally {
      setIsDeleting(false);
    }
  };

  return { deleteSwarmSession, isDeleting };
};
